import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as react from "react";
import { LineContainerComponent } from "../../sharedComponents/lineContainerComponent.js";
import { TextInputLineComponent } from "shared-ui-components/lines/textInputLineComponent.js";
import { TextLineComponent } from "shared-ui-components/lines/textLineComponent.js";
import { PropertyTypeForEdition, GetSmartFilterEditableProperties } from "smart-filters";
import { CheckBoxLineComponent } from "../../sharedComponents/checkBoxLineComponent.js";
import { FloatSliderComponent } from "../../sharedComponents/floatSliderComponent.js";
import { FloatLineComponent } from "shared-ui-components/lines/floatLineComponent.js";
import { Vector2LineComponent } from "shared-ui-components/lines/vector2LineComponent.js";
import { OptionsLine } from "shared-ui-components/lines/optionsLineComponent.js";
import { Observable } from "core/Misc/observable.js";
import { DynamicOptionsLine } from "../../sharedComponents/dynamicOptionsLineComponent.js";
import { OutputBlockName } from "../../configuration/constants.js";
export class GenericPropertyComponent extends react.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (_jsxs(_Fragment, { children: [_jsx(GeneralPropertyTabComponent, { stateManager: this.props.stateManager, nodeData: this.props.nodeData }), _jsx(GenericPropertyTabComponent, { stateManager: this.props.stateManager, nodeData: this.props.nodeData })] }));
    }
}
export class GeneralPropertyTabComponent extends react.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const block = this.props.nodeData.data;
        const isOutputBlock = block.blockType === OutputBlockName;
        return (_jsx(_Fragment, { children: _jsxs(LineContainerComponent, { title: "GENERAL", children: [!isOutputBlock && (_jsx(TextInputLineComponent, { label: "Name", propertyName: "name", target: block, lockObject: this.props.stateManager.lockObject, onChange: () => this.props.stateManager.onUpdateRequiredObservable.notifyObservers(block) })), _jsx(TextLineComponent, { label: "Type", value: block.blockType }), !isOutputBlock && (_jsx(TextInputLineComponent, { label: "Comments", propertyName: "comments", lockObject: this.props.stateManager.lockObject, target: block, onChange: () => this.props.stateManager.onUpdateRequiredObservable.notifyObservers(block) }))] }) }));
    }
}
export class GenericPropertyTabComponent extends react.Component {
    constructor(props) {
        super(props);
    }
    forceRebuild(notifiers) {
        if (!notifiers || notifiers.update) {
            this.props.stateManager.onUpdateRequiredObservable.notifyObservers(this.props.nodeData.data);
        }
        if (!notifiers || notifiers.rebuild) {
            this.props.stateManager.onRebuildRequiredObservable.notifyObservers();
        }
        // if (notifiers?.activatePreviewCommand) {
        //     (this.props.stateManager.data as GlobalState).onPreviewCommandActivated.notifyObservers(true);
        // }
        // notifiers?.callback?.((this.props.stateManager.data as GlobalState).engine);
    }
    componentDidUpdate(prevProps) {
        // if (prevProps.nodeData.data !== this.props.nodeData.data) {
        //     this.forceUpdate();
        // }
        // Check if options for a specific block changed
        const currentOptions = GetSmartFilterEditableProperties(this.props.nodeData.data);
        const prevOptions = GetSmartFilterEditableProperties(prevProps.nodeData.data);
        if (JSON.stringify(currentOptions) !== JSON.stringify(prevOptions)) {
            this.forceUpdate();
        }
    }
    render() {
        const block = this.props.nodeData.data;
        const propStore = GetSmartFilterEditableProperties(block);
        if (!propStore.length) {
            return _jsx(_Fragment, {});
        }
        const componentList = {};
        const groups = [];
        for (const propDescription of propStore) {
            const { displayName, type, groupName, options } = propDescription;
            let propertyName = propDescription.propertyName;
            let target = block;
            // If we are targeting a sub property, update the target and property name we pass to the UI accordingly
            if (options.subPropertyName) {
                target = block[propertyName];
                propertyName = options.subPropertyName;
            }
            let components = componentList[groupName];
            if (options.blockType) {
                if (options.blockType !== block._blockType) {
                    continue;
                }
            }
            if (!components) {
                components = [];
                componentList[groupName] = components;
                groups.push(groupName);
            }
            switch (type) {
                case PropertyTypeForEdition.Boolean: {
                    components.push(_jsx(CheckBoxLineComponent, { label: displayName, target: target, propertyName: propertyName, onValueChanged: () => this.forceRebuild(options.notifiers) }, `checkBox-${propertyName}`));
                    break;
                }
                case PropertyTypeForEdition.Float: {
                    components.push(_jsx(FloatSliderComponent, { lockObject: this.props.stateManager.lockObject, label: displayName, propertyName: propertyName, target: target, min: options.min ?? null, max: options.max ?? null, onChange: () => this.forceRebuild(options.notifiers) }, `slider-${propertyName}`));
                    break;
                }
                case PropertyTypeForEdition.Int: {
                    components.push(_jsx(FloatLineComponent, { lockObject: this.props.stateManager.lockObject, digits: 0, step: "1", isInteger: true, label: displayName, propertyName: propertyName, target: target, onChange: () => this.forceRebuild(options.notifiers) }, `float-${propertyName}`));
                    break;
                }
                case PropertyTypeForEdition.Vector2: {
                    components.push(_jsx(Vector2LineComponent, { lockObject: this.props.stateManager.lockObject, label: displayName, propertyName: propertyName, target: target, onChange: () => this.forceRebuild(options.notifiers) }, `vector2-${propertyName}`));
                    break;
                }
                case PropertyTypeForEdition.List: {
                    const props = {
                        label: displayName,
                        target,
                        propertyName: propertyName,
                        valuesAreStrings: options.valuesAreStrings ?? false,
                        onSelect: () => this.forceRebuild(options.notifiers),
                    };
                    // Observable options use a different, self-managing component
                    // so that several instances of it can be created
                    if (options.options instanceof Observable) {
                        components.push(_jsx(DynamicOptionsLine, { ...props, optionsObservable: options.options }, `list-${propertyName}`));
                    }
                    else {
                        components.push(_jsx(OptionsLine, { ...props, options: options.options ?? [] }, `list-${propertyName}`));
                    }
                    break;
                }
            }
        }
        return (_jsx(_Fragment, { children: groups.map((group) => (_jsx(LineContainerComponent, { title: group, children: componentList[group] }, `group-${group}`))) }));
    }
}
//# sourceMappingURL=genericNodePropertyComponent.js.map